var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 46,
    viewBox: "0 0 45 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.5 34.2285H33.75V17.8223L22.5 24.8535L11.25 17.8223V34.2285H7.5V11.7285H9.75L22.5 19.6973L35.25 11.7285H37.5M37.5 7.97852H7.5C5.41875 7.97852 3.75 9.64727 3.75 11.7285V34.2285C3.75 35.2231 4.14509 36.1769 4.84835 36.8802C5.55161 37.5834 6.50544 37.9785 7.5 37.9785H37.5C38.4946 37.9785 39.4484 37.5834 40.1516 36.8802C40.8549 36.1769 41.25 35.2231 41.25 34.2285V11.7285C41.25 9.64727 39.5625 7.97852 37.5 7.97852Z",
    fill: "#6D95FC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGmail);
export default __webpack_public_path__ + "static/media/gmail.4ddb25ebde0f50c60f07105692814d62.svg";
export { ForwardRef as ReactComponent };